import css from './wallet-header.module.scss';
import {WalletHeaderProps} from './wallet-header.types';

export const WalletHeader = ({balance}: WalletHeaderProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.title}>My Wallet</div>
			<div className={css.balance}>BALANCE</div>
			<div className={css.value}>{balance} SET</div>
		</div>
	);
};
